"use client";

import React, { useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSpiritOfTheMill() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1,
    once: true
  });
  const scrollLineRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = scrollLineRef.current;
    if (!el) return;
    let frame: number;
    let start: number | null = null;
    const duration = 2000;
    const animate = (ts: number) => {
      if (!start) start = ts;
      const elapsed = ts - start;
      const progress = elapsed % duration / duration;
      const opacity = Math.sin(progress * Math.PI);
      el.style.opacity = String(0.3 + opacity * 0.7);
      frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, []);
  return <section data-section-id="230793" id="your-next-great-story-starts-here" className="bg-background text-foreground relative w-full h-screen min-h-screen overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline className="w-full h-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650028/img/mountain_dawn_cinematic_poster.png">
          <source src="/img/mountain_dawn_cinematic.mp4" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0" style={{
        background: "linear-gradient(to bottom, rgba(10,10,14,0.4) 0%, rgba(10,10,14,0.2) 50%, rgba(10,10,14,0.5) 100%)"
      }} />
        {}
        <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.3) 100%)"
      }} />
      </div>

      {}
      <div ref={contentRef} className="relative z-10 flex flex-col items-center justify-center text-center px-4" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(32px)",
      transition: "opacity 1.2s ease, transform 1.2s ease"
    }}>
        {}
        <p className="font-default text-xs tracking-widest uppercase mb-6 font-semibold" style={{
        color: "var(--primary)",
        letterSpacing: "0.3em"
      }}>
          Curated Expeditions &bull; Global Discovery
        </p>

        {}
        <h1 className="font-default font-bold uppercase leading-none text-center !text-[rgba(255,255,255,1)]" style={{
        fontFamily: "var(--font-serif)",
        fontSize: "clamp(3rem, 10vw, 7.5rem)",
        color: "var(--foreground)",
        textShadow: "0 4px 40px rgba(0,0,0,0.3)",
        letterSpacing: "0.04em"
      }}>
          YOUR NEXT GREAT STORY STARTS HERE
        </h1>

        {}
        <div className="flex items-center justify-center w-full mt-8 mb-8 gap-4">
          <div className="h-px flex-1 max-w-32" style={{
          background: "var(--primary)"
        }} />
          <div className="w-2 h-2 rotate-45" style={{
          background: "var(--primary)"
        }} />
          <div className="h-px flex-1 max-w-32" style={{
          background: "var(--primary)"
        }} />
        </div>

        {}
        <p className="font-default text-base mb-10 max-w-md font-medium !text-[rgba(255,255,255,1)] md:text-lg" style={{
        color: "var(--muted-foreground)",
        letterSpacing: "0.05em"
      }}>
          Bespoke travel experiences designed for the modern explorer
        </p>

        {}
        <Link to="#">
          <Button size="lg" className="font-default uppercase tracking-widest px-10 py-4 text-sm border transition-all duration-300 hover:scale-105 font-semibold rounded-full" style={{
          background: "linear-gradient(135deg, var(--primary) 0%, var(--chart-3) 100%)",
          color: "var(--primary-foreground)",
          borderColor: "var(--primary)",
          boxShadow: "0 10px 20px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.15)",
          letterSpacing: "0.2em"
        }}>
            Begin Your Voyage
          </Button>
        </Link>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3" style={{
      color: "var(--muted-foreground)"
    }}>
        <span className="font-default text-xs uppercase font-semibold" style={{
        letterSpacing: "0.2em",
        color: "var(--primary)"
      }}>
          Explore
        </span>
        <div ref={scrollLineRef} className="w-px bg-current" style={{
        height: "48px",
        background: "var(--primary)"
      }} />
        <ChevronDown className="w-4 h-4" style={{
        color: "var(--primary)"
      }} />
      </div>
    </section>;
}